import { fetchData } from '../api/api';
import { handleError } from '../context/errors/errorUtils';

// Поля, которые мы используем в модуле "Экзамен"
const allowedExamFields = ['examId', 'step', 'userId', 'completeBlock', 'recognizedText'];

const createExamFormData = (data) => {
  const formData = new FormData();

  if (data.audioBuffer) {
    formData.append('audio', new Blob([data.audioBuffer], { type: 'audio/wav' }), 'audio.wav');
  }
  Object.entries(data).forEach(([key, value]) => {
    if (allowedExamFields.includes(key) && value !== undefined) {
      formData.append(key, value);
    }
  });

  return formData;
};

// вызывается при каждой отправке файла. 
export const sendExamData = async (data = {}) => {
  try {
    const formData = createExamFormData(data);
    return await fetchData('/api/exam', 'POST', formData);
  } catch (error) {
    handleError({
      code: 'EXAM_DATA_FETCH_ERROR',
      error,
      context: {
        module: 'sendExamData',
        examId: data.examId,
        userId: data.userId,
        step: data.step,
      },
      showToUser: false,
    });
    throw error;
  }
};
 
// completeExam - вызывается переодически для проверки результатов экзамена! 
export const completeExam = async ({ userId, examId }) => {
   try {
     const data = await sendExamData({ userId, examId, completeBlock: true });
	 //console.log(data);
     return data; // Ожидаем получить оценку и feedback
   } catch (error) {
     //console.error('Ошибка при завершении экзамена:', error);
     throw error;
   }
 };


// =================== отдельные функции, вызываемые не через общий handler, а напрямую
// берём набор вопросов для выбранного пользователем id экзамена 
export const fetchExamQuestions = async ({ userId, examId, setData, setIntro, setLoading, setError, setLimitReached }) => {
    try {
      const data = await sendExamData({ userId, examId, step: 0 });

	  // Обработка лимита экзаменов 
		if (data?.error === 'EXAM_LIMIT_REACHED') {
		  setLimitReached?.({
			message: data.message,
			vip: data.vip,
			examsToday: data.examsToday,
			examLimit: data.examLimit
		  });
		  return null;
		}	  
	  // обработка всего остального 	
      if (!data || !data.questions) {
        throw new Error('Нет questions в ответе от сервера');
      }	  
      setData?.(data.questions);
      setIntro?.(data.intro);
	  setLoading?.(true);
      return data;
    } catch (error) {
      setError?.(error);
      throw error;
    } finally {
      setLoading?.(false);
    }
  };
  
// берём темы и прогресс пользователя при заходе в модуль Экзамены  
export const fetchExamTopics = async ({ userId, setData, setLoading, setError }) => {
	try {
	const data = await sendExamData({ userId }); // step и examId не нужны
	  setData?.(data);
	return data;
	} catch (error) {
	  setError?.(error);
	throw error;
	} finally {
	  setLoading?.(false);
	}
};





